import { StyleSheet } from "react-native"

export const sharedStyles = StyleSheet.create({
  contentContainer: {
    flexGrow: 1,
    paddingTop: 4,
    paddingLeft: 2 * 4,
    paddingRight: 2 * 4,
    width: "100%",
    maxWidth: 1200,
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: 3 * 4,
  },
  contentContainerWide: {
    flexGrow: 1,
    paddingTop: 4,
    paddingLeft: 2 * 4,
    paddingRight: 2 * 4,
    width: "100%",
    maxWidth: 1400,
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: 3 * 4,
  },
})
